<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
import { SearchProps } from "./Search.props"

const props = withDefaults(defineProps<SearchProps>(), {
  disabled: false,
  showIconLeft: false
})

const emit =
  defineEmits<{
    (e: "onInput", value: string): void
    (e: "onIconDxClick"): void
    (e: "onFocusIn"): void
    (e: "onFocusOut"): void
    (e: "update:modelValue", value: string): string
  }>()

const inputSearch = ref()

const isValid = computed(() => {
  if (inputSearch.value) {
    const node = inputSearch.value.node
    if (node.context.state.dirty && node.context.state.rules)
      return node.context.state.complete
  }
  return true
})

const isFocused = ref(false)

const handleFocusIn = () => {
  isFocused.value = true
  emit("onFocusIn")
}

const handleFocusOut = () => {
  isFocused.value = false
  emit("onFocusOut")
}

const value = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    if (!value) value = ""
    emit("update:modelValue", value)
  }
})

const search = () => {
  console.log("search")
}

const cleanValue = () => {
  value.value = ""
}
</script>

<template>
  <div>
    
<FormKitLazyProvider config-file="true">
<FormKit
      ref="inputSearch"
      :id="name"
      :name="name"
      type="text"
      :placeholder="placeholder"
      :disabled="disabled"
      v-model="value"
      :classes="{
        outer: 'relative',
        wrapper: 'relative bg-inherit',
        label: 'sr-only',
        input: {
          'py-[10px] pl-4 w-full input-text__textfield bg-white rounded-[100px]': true,
          'error-border__textfield': !isValid,
          '!pl-11 pr-8': showIconLeft,
          'pr-16': !showIconLeft,
          'text-grey-200 placeholder:text-grey-200': disabled
        }
      }"
      @focusin="handleFocusIn"
      @focusout="handleFocusOut"
    >
      <template #prefixIcon>
        <button
          v-if="showIconLeft"
          type="button"
          class="absolute left-4 top-1/2 -translate-y-1/2 text-black-40"
          :disabled="disabled"
          @click="search"
        >
          <UtilsIcon name="Search.svg" color="black-40" class="h-6 w-6" />
        </button>
      </template>
      <template #suffixIcon>
        <button
          v-if="!!value"
          @click="cleanValue"
          :disabled="disabled"
          class="absolute top-1/2 -translate-y-1/2 text-black-80"
          :class="[
            { 'text-black-80/25': disabled },
            showIconLeft ? 'right-4' : 'right-10'
          ]"
        >
          <UtilsIcon name="CloseCircleFull.svg" color="black-80" class="h-4 w-4" />
        </button>
        <button
          :disabled="disabled"
          v-if="!showIconLeft"
          @click="search"
          class="absolute right-4 top-1/2 -translate-y-1/2 text-black-40"
        >
          <UtilsIcon name="Search.svg" color="black-40" class="h-6 w-6" />
        </button>
      </template>
    </FormKit>
</FormKitLazyProvider>

  </div>
</template>
